import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import AxiosInstance from "../../components/Axios";
import {MRT_ColumnFiltersState, MRT_PaginationState, MRT_SortingState} from "material-react-table";
import {
    DatiProg,
    DatiProgApiResponse, DatiProgDTOApiResponse, mapDatiProgToJson, mapJsonToDatiProg, mapJsonToDatiProgApiResponse,mapJsonToDatiProgDTOApiResponse
} from "./types";
import {mapJsonToProgettiApiResponse, ProgettiApiResponse} from "../gestversore/types";
import {columnFiltersParamWithDateRange, sortingParam} from "../../common/Services";
import {Buffer} from "buffer";
import {format} from "date-fns";
import * as Yup from "yup";



const moment = require('moment')







export function useGetDatiProgDTO(
    pagination: MRT_PaginationState,
    columnFilters: MRT_ColumnFiltersState,
    globalFilter: string,
    sorting: MRT_SortingState,
 ) {
    return useQuery<DatiProgDTOApiResponse>({
        queryKey: [
            'fetchDatiProgDTO',
            columnFilters, // refetch when columnFilters changes
            globalFilter,  // refetch when globalFilter changes
            pagination.pageIndex, // refetch when pagination.pageIndex changes
            pagination.pageSize, // refetch when pagination.pageSize changes
            sorting, // refetch when sorting changes
        ],
        queryFn: async () => {
            // Get isAdmin and coddip from localStorage at the start

            let coddip = localStorage.getItem('coddip') || 'NN';
            let impcoddip = localStorage.getItem('impcoddip') || 'NN';
            const role = localStorage.getItem('keyrole') || '';

            if (role.includes('TimeReportAdmin')  || role.includes('TimeReportDatiProgetto')) {
                                coddip = (impcoddip.trim() === 'NN' || impcoddip.trim() === '') ? '' : impcoddip.trim();
                            } else if (role.includes('TimeReportUser')) {
                                coddip = localStorage.getItem('coddip') || 'NN';
                            } else if (role.includes('TimeReportCust')) {
                                coddip = 'NN';
                            } else if (role.includes('TimeReportAgent')) {
                                coddip = '';
                            }



            const myLimit=pagination.pageSize
            const myOffset =
                pagination.pageIndex === 0
                    ? '0'
                    : `${pagination.pageSize * pagination.pageIndex}`;



            let myURL = `?limit=${myLimit}&offset=${myOffset}&search=${globalFilter ?? ''}${columnFiltersParamWithDateRange(
                columnFilters,
                'VBT25'
            )}&ordering=${sortingParam(sorting, 'VBT25')}`;

            if (coddip !== '') {
                        myURL += `&VBT25_REF=${coddip}`;
                }

            const response = await AxiosInstance.get(`datiprogdto/${myURL}`);

            return mapJsonToDatiProgDTOApiResponse(response.data);
        },
        refetchOnWindowFocus: false,
    });
}


export function useGetDatiProgByCodProg(id: string) {
  return useQuery<DatiProg>({
    queryKey: ['fetchDatiProgByCodProg', id],
    queryFn: async () => {

      const response = await AxiosInstance.get('datiprog/'+id+'/');

      // Log the response data itself
      // console.log('Raw response data:', response.data);

      const transformedData = mapJsonToDatiProg(response.data.data.DatiProg);

      // Log the transformed data
      // console.log('Transformed data:', transformedData);

      return transformedData;
    },
    refetchOnWindowFocus: false,
  });
}






export function useCreateDatiProg() {
  const queryClient = useQueryClient();
  return useMutation({

    mutationFn: async (datiprog: DatiProg) => {
      // if (datiprog.datareg) {
      //   datiprog.datareg = moment(datiprog.datareg).format('YYYY-MM-DD');
      // }
      //
      // if (datiprog.datains) {
      //   datiprog.datains = moment(datiprog.datains).format('YYYY-MM-DD');
      // }

       const response = await AxiosInstance.post('datiprog/0/', mapDatiProgToJson(datiprog));
       return response.data;

      // return AxiosInstance.post('datiprog/0/',mapDatiProgToJson(datiprog));
    },

     onSuccess: async (data, variables) => {

       queryClient.invalidateQueries({ queryKey: ['fetchDatiProgDTO'] });

   }, //refetch VersoOre after mutation, disabled for demo
     });
}

export function useUpdateDatiProg() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (datiprog: DatiProg) => {

      const dateFields = ['data1sal', 'data2sal', 'data3sal', 'data4sal', 'data5sal','datakickoffpian', 'datakickoffeff', 'datagantt', 'datagolivepian', 'datagoliveeff',
        'datafirmakickoff', 'datacoll', 'datapercomp', 'dataagg' ];

      dateFields.forEach((field) => {
        if (datiprog[field as keyof DatiProg]) {
          datiprog[field as keyof DatiProg] = moment(datiprog[field as keyof DatiProg]).format('YYYY-MM-DD');
        }
      });

      // console.log(datiprog);
      const response = await AxiosInstance.patch(`datiprog/${datiprog.id}/`, mapDatiProgToJson(datiprog));
      return response.data;
    },
    onSuccess: async () => {
      queryClient.invalidateQueries({ queryKey: ['fetchDatiProgDTO'] });
    },
  });
}



export function useDeleteDatiProg() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (codprog: String) => {


    const response = await AxiosInstance.delete('datiprog/'+codprog+'/');
     return  response.data
    },
     onSuccess: async (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['fetchDatiProgDTO'] });
    },
  });
}

// export async function jasperDatiProgDTOBlob( ditta: String, codprog: String, formato: String) {
export async function jasperDatiProgDTOBlob(  formato: String) {
  try {
    const username = 'jasperadmin';
    const password = 'Tibco2024@';
    const base64encodedData = Buffer.from(`${username}:${password}`).toString('base64');

    // const fromDateString = fromDate ? format(fromDate, 'yyyy-MM-dd') : '';
    // const toDateString = toDate ? format(toDate, 'yyyy-MM-dd') : '';

         let pag = '';
             if (formato === 'xlsx') {
                pag = 'ignorePagination=true&'
            }

    // check codcli = 0 for admin

      // const mycodprog = codprog === '0' ? '' : codprog;

   // const response = await fetch(`${BASE_URL_JASPERSERVER}/rest_v2/reports/reports/datiprogetto${formato}.${formato}?${pag}codprog=${mycodprog}&ditta=${ditta}`, {
    const response = await fetch(`${BASE_URL_JASPERSERVER}/rest_v2/reports/reports/datiprogetto${formato}.${formato}?${pag}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/'+formato,
        'Authorization': `Basic ${base64encodedData}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch the report');
    }

    const blob = await response.blob();
    return blob;
  } catch (error) {
    console.error('Error generating report:', error);
    throw error; // Rethrow the error to handle it in the calling code if needed
  }
};

export const validationSchema = Yup.object().shape({
                      // fromDate: Yup.date().required('Selezione Data Inizio'),
                      // toDate: Yup.date().test('is-after-or-equal', 'La data di fine deve essere successiva alla data di inizio', function (value) {
                      //                    const { fromDate } = this.parent; // Access fromDate from parent object
                      //                    if (!fromDate || !value) {
                      //                    return true; // Skip validation if fromDate or toDate is not set
                      //                 }
                      //                 return fromDate <= value; // Validate if toDate is after or equal to fromDate
                      //               }),
                      emailTo: Yup.string().email('Email non è valida'),
                    });


